import { render, staticRenderFns } from "./AdvancedOptions.vue?vue&type=template&id=507a5b90&scoped=true&"
import script from "./AdvancedOptions.vue?vue&type=script&lang=js&"
export * from "./AdvancedOptions.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedOptions.vue?vue&type=style&index=0&id=507a5b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a5b90",
  null
  
)

export default component.exports